module.exports = __webpack_public_path__ + "static/img/default_head.5c087e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/default_head.jpg
// module id = 1039
// module chunks = 1